import { DefaultFilter } from './defaultFilter';
import { AbstractFilter } from './abstractFilter';

const operatorLabels = {
  eq: 'Equals',
  neq: 'Not Equals',
  ncnt: 'Not Contains',
  cnt: 'Contains',
};
const matchTypeLabels = {
  any: 'Any',
  all: 'All',
};

export class ObjectFilter extends AbstractFilter {
  constructor() {
    super();
    this.defaultFilter = new DefaultFilter();
  }

  getOperatorLabel(operator, matchType) {
    const matchTypeStr = matchTypeLabels[matchType] || matchType;
    const operatorRecord = this.filter?.operators?.find((op) => op.key === operator);
    if (operatorRecord) {
      return `(${operatorRecord.name}${matchTypeStr ? ` ${matchTypeStr}` : ''})`;
    }
    return operator && typeof operator === 'string'
      ? `(${operatorLabels[operator] || operator}${matchTypeStr ? ` ${matchTypeStr}` : ''})` : '';
  }

  getDisplayNameForObject(record) {
    const opLabel = this.getOperatorLabel(record.operator, record.matchType);
    let internalValue = record.displayName || this.getDisplayName(record.value);
    if (!internalValue) return null;

    if (record.key || record.name) {
      if (record.name === internalValue) internalValue = '';
      return `${opLabel} ${record.name || record.key}${internalValue !== '' ? `: ${internalValue}` : ''}`.trim();
    }
    return `${opLabel} ${internalValue}`.trim();
  }

  getDisplayNameForArray(record) {
    const opLabel = this.getOperatorLabel(record.operator, record.matchType);

    const arrayOfValues = record.value?.map((element) => this.getDisplayName(element)).filter(Boolean);
    const internalValue = arrayOfValues.join(', ');
    if (!internalValue) return null;
    return `${opLabel} ${internalValue}`.trim();
  }

  getDisplayName(record) {
    if (record?.checked) return record.name || '';

    if (Array.isArray(record?.value)) return this.getDisplayNameForArray(record);

    if (typeof record === 'object' && record) return this.getDisplayNameForObject(record);

    return this.filter?.key ? this.defaultFilter.getDisplayName(record) : null;
  }
}
